import { Components, Theme } from '@mui/material'

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  defaultProps: {
    ChipProps: {
      size: 'small',
    },
  },
  styleOverrides: {
    paper: ({ theme }) => ({
      border: 'none',
      boxShadow: [
        '0px 8px 16px rgba(0, 0, 0, 0.08)',
        `inset 0 0 0 1px ${theme.palette.neutralLight?.[300] ?? theme.palette.divider}`,
      ].join(', '),
    }),

    groupLabel: ({ theme }) => ({
      ...theme.typography.HeaderSubtitleSmallRegular,
      color: theme.palette.text.secondary,
      marginLeft: '1px',
      marginRight: '1px',
      lineHeight: '155%',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    }),
  },
}
